 if (!customElements.get('scrolling-banner')) {

  const ScrollingBanner = class extends HTMLElement {

    constructor() {

      super();

      window.initLazyScript(this, this.init.bind(this));

    }



init() {
  // Load all countdown timers
  customElements.whenDefined('countdown-timer').then(() => {
    this.querySelectorAll('countdown-timer').forEach((el) => el.init());
  });

  // Load all images
  this.querySelectorAll('img[loading="lazy"]').forEach((el) => {
    el.loading = 'eager';
  });

  const rotator = this.querySelector('.rotator');
  const marquee = this.querySelector('.marquee');
  marquee?.classList.add('marquee--animate'); // force visibilité (le thème l'utilise comme "ready")
  marquee?.classList.add('marquee--static');  // on va couper l'anim marquee via CSS
  if (!rotator) {
    // fallback: comportement actuel si tu gardes un marquee ailleurs
    document.fonts.ready.then(() => this.querySelector('.marquee')?.classList.add('marquee--animate'));
    return;
  }

  const items = Array.from(rotator.querySelectorAll('.rotator__item'));
  if (items.length <= 1) {
    items[0]?.classList.add('is-active');
    return;
  }

  // interval basé sur ton setting speed (tu utilises déjà 42 - speed)
  const intervalStr = getComputedStyle(rotator).getPropertyValue('--interval').trim(); // ex "5s"
  const intervalMs = Math.max(1500, (parseFloat(intervalStr) || 4) * 1000);

  let index = 0;
  items.forEach((el, i) => el.classList.toggle('is-active', i === 0));

  // évite plusieurs timers si re-init
  if (this._rotatorTimer) clearInterval(this._rotatorTimer);

  this._rotatorTimer = setInterval(() => {
    items[index].classList.remove('is-active');
    index = (index + 1) % items.length;
    items[index].classList.add('is-active');
  }, intervalMs);
}};

window.customElements.define('scrolling-banner', ScrollingBanner);

} 